import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TqaLogo from '../assets/TQA-Logo-White.png';

const LoginPage = () => {
  const { user, loading, error, loginWithGoogle } = useAuth();
  const location = useLocation();
  const fromLocation = location.state?.from;
  const redirectTo = fromLocation
    ? `${fromLocation.pathname || ''}${fromLocation.search || ''}${fromLocation.hash || ''}` || '/'
    : '/';

  if (!loading && user) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-900" style={{ backgroundColor: 'var(--tqa-black)' }}>
      <div className="w-full max-w-md p-8 rounded-lg shadow-xl" style={{ backgroundColor: 'var(--tqa-surface)' }}>
        <div className="flex justify-center mb-10">
          <img src={TqaLogo} alt="TQA" className="w-32 h-auto object-contain" />
        </div>

        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-white mb-2">Sign in</h1>
          <p className="text-sm text-gray-400">
            Use your TQA Google account to continue.
          </p>
        </div>

        {error && (
          <div className="mb-6 px-4 py-3 text-sm rounded bg-red-900/20 text-red-400 border border-red-900/50 text-center">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={() => loginWithGoogle(redirectTo)}
          className="w-full inline-flex items-center justify-center gap-3 py-3 text-sm font-medium uppercase tracking-widest transition-all duration-150 hover:brightness-110 rounded"
          style={{ backgroundColor: 'var(--tqa-green)', color: 'var(--tqa-black)' }}
        >
          <span className="h-5 w-5 flex-shrink-0" aria-hidden="true">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className="h-5 w-5">
              <path fill="#4285f4" d="M507.9 208.1H260.6v98.1h141.6c-6.1 32.5-24.6 60.1-52.4 78.6v65.2H440c63.8-58.7 67.9-161.9 67.9-171.9 0-10.1-.5-20.1-2-30z" />
              <path fill="#34a853" d="M260.6 512c70 0 128.8-23.4 171.7-62.1l-82.6-64.6c-23.1 15.5-52.8 24.6-89.1 24.6-68 0-125.7-45.9-146.4-107.4H28.2v67.6C71 463.4 159.2 512 260.6 512z" />
              <path fill="#fbbc04" d="M114.2 302.5c-4.8-14.4-7.5-29.7-7.5-45.5 0-15.8 2.7-31.1 7.8-45.5V144H28.2C10.2 180.7 0 221.3 0 257c0 35.8 10.2 76.3 28.2 113l86-67.5z" />
              <path fill="#ea4335" d="M260.6 100.1c37.8 0 71.5 13 98.2 38.5l73.8-73.8C389.2 23.1 330.6 0 260.6 0 159.2 0 71 48.6 28.2 144l86.1 67.6C134.9 146 192.7 100.1 260.6 100.1z" />
            </svg>
          </span>
          Continue with Google
        </button>

        <p className="mt-8 text-xs text-center text-gray-500">
          Access is limited to authorised TQA accounts.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
